module.exports = __webpack_public_path__ + "static/media/java.8f5b42ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills/backend/java.png
// module id = 1518
// module chunks = 0